import { render, staticRenderFns } from "./recommendView.vue?vue&type=template&id=42ed75e4&"
import script from "./recommendView.vue?vue&type=script&lang=js&"
export * from "./recommendView.vue?vue&type=script&lang=js&"
import style0 from "./recommendView.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports